import { useLazyQuery } from "@apollo/client/react";
import moment from 'moment';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DecodeFormBase64 } from '../../helpers/tools';
import Cookies from 'universal-cookie';

import { GET_PAGE_PERMISSION } from '../../data/graphQL/queries/getPagePermission';

export const useAuth = () => {
  const cookies = new Cookies();
  const tokenUsu = sessionStorage.getItem("accessToken");
  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);
  const location = useLocation();
  const [getPermission, { data: valid, called: queryIsTriggered }] = useLazyQuery(GET_PAGE_PERMISSION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (tokenUsu === null || !tokenUsu || idUsuario === null || idUsuario == '' || idUsuario === 0) {
      return;
    }

    // verifico que sea válido
    let fechaValidez = sessionStorage.getItem("accessTokenValidTo");

    if (fechaValidez == null || !fechaValidez) {
      return;
    }

    // verifico que no esté vencido
    var fechaActual = moment.utc();
    var fechaToken = moment.utc(fechaValidez.toString());
    const tiempoSesionRestante = fechaToken.diff(fechaActual, 'seconds');

    if (tiempoSesionRestante > 0) {
      let pathCheck = location.pathname;

      // en caso de que se trate de una página de la versión anterior el path comienza con /menu/ y luego
      // el path encriptado. Se limpia la ruta y desencripta para consultar.
      if (pathCheck.includes('/menu/')) {
        pathCheck = DecodeFormBase64(pathCheck.split('/menu/')[1]);
      }

      if (!queryIsTriggered) {
        getPermission({ variables: { idUsuario: idUsuario, path: pathCheck } });
      }
    }
  }, [tokenUsu, idUsuario, location.pathname, queryIsTriggered, getPermission]);

  // Determinar el acceso basado en la respuesta
  if (tokenUsu === null || !tokenUsu || idUsuario === null || idUsuario == '' || idUsuario === 0) {
    return false;
  }

  let fechaValidez = sessionStorage.getItem("accessTokenValidTo");
  if (fechaValidez == null || !fechaValidez) {
    return false;
  }

  var fechaActual = moment();
  var fechaToken = moment(fechaValidez, "DD/MM/YYYY h:mm:ss a");
  const tiempoSesionRestante = fechaToken.diff(moment(fechaActual, "DD/MM/YYYY h:mm:ss a"), 'seconds');

  if (tiempoSesionRestante <= 0) {
    return false;
  }

  if (valid != null) {
    if (valid.permisoPagina.success) {
      const acceso = valid.permisoPagina.valorEsperado;
      // si no tiene acceso limpio el storage antes de salir
      if (!acceso) {
        sessionStorage.clear();
        cookies.remove("accessToken");
        cookies.remove("idUsuario");
        cookies.remove("auditoria_filter_accion");
        cookies.remove("auditoria_filter_fechaDesde");
        cookies.remove("auditoria_filter_fechaHasta");
      }
      return acceso;
    } else {
      return false;
    }
  }

  return true;
};